import React, { useEffect } from 'react'

import "./Proximamente.css"
import FilterProducts from '../../Components/FilterProducts/FilterProducts'
import ProductsList from '../../Components/ProductsList/ProductsList'
import SideBarComponent from '../../Components/SideBarComponent/SideBarComponent'

const Proximamente = () => {
    const [loading, setLoading] = React.useState<boolean>(true);
    const [filterTCG, setFilterTCG] = React.useState<string[]>([]);
    const [filterTipo, setFilterTipo] = React.useState<string[]>([]);
    const [filterIdioma, setFilterIdioma] = React.useState<string[]>([]);
    const [filterCategory, setFilterCategory] = React.useState<string[]>([]);
    const [openResponsiveFilters, setOpenResponsiveFilters] = React.useState<boolean>(false);

  return (
    <>
    <SideBarComponent open={openResponsiveFilters} setOpen={setOpenResponsiveFilters}>
      <FilterProducts filterCategory={filterCategory} setFilterCategory={setFilterCategory} loading={loading} filterIdioma={filterIdioma} filterTCG={filterTCG} filterTipo={filterTipo} setFilterIdioma={setFilterIdioma} setFilterTCG={setFilterTCG} setFilterTipo={setFilterTipo} />
    </SideBarComponent>
    
    <div className='layout-page'>
        <div className='Products-Section'>
            <div className='Products-Filter-section'>
                <FilterProducts filterCategory={filterCategory} setFilterCategory={setFilterCategory} loading={loading} filterIdioma={filterIdioma} filterTCG={filterTCG} filterTipo={filterTipo} setFilterIdioma={setFilterIdioma} setFilterTCG={setFilterTCG} setFilterTipo={setFilterTipo} />

            </div>

            <div className='Products-filter-list'>
              <ProductsList filterCategory={filterCategory} setFilterOpen={setOpenResponsiveFilters} filterIdioma={filterIdioma} filterTCG={filterTCG} filterTipo={filterTipo} type='soon' loading={loading} setLoading={setLoading} ></ProductsList>
            </div>
        </div>
    </div>
    </>

  )
}

export default Proximamente